export const LOCALE_STORAGE_KEY = 'iampam-itops-portal.locale' as const;

export const SUPPORTED_LOCALES = ['ko', 'en'] as const;

export type PortalLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: PortalLocale = 'ko';

export const PORTAL_I18N_NAMESPACES = [
  'common',
  'auth',
  'adminNav',
  'layout',
  'services',
  'admin',
] as const;

export type PortalI18nNamespace = (typeof PORTAL_I18N_NAMESPACES)[number];
